import cloneDeep from 'lodash.clonedeep';
/**
 * Logs message into console if proper UTM set to truthy value.
 * @param {object} - Configuration with log details.
 * @param {('log'|'warn'|'error'|'info'|'table')} [type = 'log'] - Type of console, if not specified defaults to "log".
 * @param {string | number} [subName] - additional service name subtype, can be used to log error code number
 * @param {unknown[]} [messages] - Data to be displayed as in console.
 */
const log = (config, type = 'log', subName, ...messages) => {
    const { name, fColor, bColor } = config;
    const style = `display: inline-block; color: ${fColor}; background: ${bColor}; padding: 1px 4px; border-radius: 3px;`;
    const badge = `%c${name}${subName ? ' ' + subName : ''}`;
    const messagesCopy = (messages !== null && messages !== void 0 ? messages : []).map((v) => cloneDeep(v));
    if (type === 'table' && messagesCopy.length === 1) {
        // print data in table, badge in the separate log
        console.log(badge, style);
        console.table(messagesCopy[0]);
    }
    else if (type === 'table' && messagesCopy.length === 2) {
        // print data in table, badge and message in the separate log
        console.log(badge, style, messagesCopy[0]);
        console.table(messagesCopy[1]);
    }
    else {
        // print any messages with a badge
        console[type](badge, style, ...messagesCopy);
    }
};
export { log };
